import axios from "axios";
import qs from "qs";
import PaginationDTO from "@/models/PaginationDTO";
import ExportTaskResponseDTO from "@/models/ExportTaskResponseDTO";
import ExportTaskListResponseDTO from "@/models/ExportTaskListResponseDTO";
import {ExportTaskCreateRequestDTO} from "@/service/exportTaskCreate";

export const exportTasks = {
    create: async (sysname: string, requestDTO: ExportTaskCreateRequestDTO): Promise<ExportTaskResponseDTO> => {
        let resp = await axios({
            url: `/export/tasks/${sysname}`,
            method: 'POST',
            data: requestDTO,
        });

        return resp.data as ExportTaskResponseDTO;
    },
    list: async (pagination: PaginationDTO): Promise<ExportTaskListResponseDTO> => {
        let resp = await axios({
            url: `/export/tasks`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as ExportTaskListResponseDTO;
    },
    get: async (id: string): Promise<ExportTaskResponseDTO> => {
        let resp = await axios({
            url: `/export/tasks/${id}`,
            method: 'GET',
        });

        return resp.data as ExportTaskResponseDTO;
    },
    cancel: async (id: string): Promise<ExportTaskResponseDTO> => {
        let resp = await axios({
            url: `/export/tasks/${id}/cancel`,
            method: 'POST',
        });

        return resp.data as ExportTaskResponseDTO;
    },
    download: async (id: string, filename?: string): Promise<Blob> => {
        let resp = await axios({
            url: `/export/tasks/${id}/download`,
            method: 'GET',
            params: filename ? {filename} : {},
            responseType: 'blob',
        });

        return resp.data as Blob;
    },
}
